import React from 'react'

// Marks a field whose value came from the issuer's discovery document.
// pulseKey changes each lookup, so the key re-mounts the span and the CSS
// highlight replays.
export const FromIssuerTag = ({ show, pulseKey }) =>
  show ? <span key={pulseKey} className="sw-from">from issuer</span> : null
